import React, { useEffect } from "react";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
const CodeConduct = () => {
  useEffect(() => {
    document.title = "Code of Conduct -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> The Almanac </li>
          <li>School Rules</li>
          <li>Code of Conduct</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Code of Conduct </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <h6>
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Code of Conduct.pdf"
                  target="_blank"
                >
                  <b>
                    <u>CIRCULAR-CODE OF CONDUCT STUDENTS</u>
                  </b>
                </Link>
              </h6>
              <p>
                The school is a place to learn and grow. To make it run smoothly
                the following code of conduct is required:{" "}
              </p>
              <ul className="list">
                <li>
                  <b>Punctuality: </b> Reporting for the assembly at 0755 hours
                  is a must. No student must be late for a class. Promptness in
                  submitting assignments and projects is necessary.{" "}
                </li>
                <li>
                  <b> Regularity: </b> One day / period missed at school is like
                  a broken link in a chain. Study regularly. Read what has been
                  taught in class on a daily basis.{" "}
                </li>
                <li>
                  <b> Discipline:</b> Students must show restraint in their
                  behaviour. Talking loudly in corridors, class rooms, assembly
                  grounds or other places in the school is not permitted.
                  Silence must be maintained when the assembly is in progress.
                  Occupy your mind in reading, solving puzzles, completing
                  assignments, when you are free. Please queue up while moving
                  from one class to another or when waiting for your turn for
                  anything.{" "}
                </li>
                <li>
                  <b> Cleanliness & Hygiene:</b> Do not litter the school. Use
                  the dustbin. Defacing walls or graffiti is ugly. Do not
                  scribble on desks, walls or doors. Maintain your report card,
                  notebooks, files and other material neatly. Keep yourself
                  clean. Nails and hair must be clean and tidy. Wear a clean and
                  well ironed uniform. Polish your shoes. Neatness is the
                  hall-mark of a successful individual.{" "}
                </li>
                <li>
                  <b> Courtesy:</b> The language of a student must reflect
                  refinement. Use of polite expressions is recommended on every
                  occasion. Learn to use 'Excuse me' 'Please' 'Thank You'
                  'Sorry' 'Could I...'liberally. Decorum must be maintained
                  while talking to teachers and seniors. Extend courtesies to
                  everyone including equals and juniors. Soft words of praise or
                  thanks can prove magical. Observing courtesies can open
                  doors.{" "}
                </li>
              </ul>
              <h6>Follow these etiquettes:</h6>
              <ul className="list">
                <li>
                  {" "}
                  Greeting young and old alike with a warm 'Hello, How are you?'
                  or 'Good Morning' according to the age and position of the
                  individual. Acknowledge the presence of a student or teacher
                  even if you do not know him or her. Greet those who clean your
                  classroom, mend your furniture, ring the bell etc.{" "}
                </li>
                <li> Holding the door for the next person. </li>
                <li> Using the wash room cleanly. </li>
                <li>
                  {" "}
                  Helping a junior board or alight from the bus. Helping him or
                  her get a seat in the bus.{" "}
                </li>
                <li> Carrying a teacher's notebooks. </li>
                <li> Using the books lent by the library well. </li>
                <li> Talking softly while others are studying. </li>
                <li> Using a tissue or a handkerchief while sneezing. </li>
                <li> Covering mouth while coughing, yawning or sneezing. </li>
                <li>
                  {" "}
                  <b>Integrity: </b> Honesty in all dealings is to be followed.
                  Be true to your friends, teachers and yourself. Cheating in
                  exams will invite heavy penalties.{" "}
                </li>
                <li>
                  {" "}
                  Completing an assignment from a guide book can never increase
                  knowledge. This will increase your trust value in the school
                  by being genuine and honest.{" "}
                </li>
                <li>
                  {" "}
                  <b>Generosity: </b> Be generous in helping others. Be a buddy
                  to a classmate who needs academic support. Do not let any one
                  copy your project, answer sheet or home assignment.{" "}
                </li>
                <li>
                  {" "}
                  <b>Quality: </b> Please do not neglect the little things.
                  Never skimp on extra effort. Giving the best should be your
                  trademark.{" "}
                </li>
                <li>
                  {" "}
                  <b>Initiative:</b> Be pro-active. Jump into the middle of
                  things by accepting responsibilities. Take charge of
                  programmes, offer help and support to teachers.{" "}
                </li>
                <li>
                  {" "}
                  <b> Awareness: </b> Stand for causes such as reduction of
                  emissions and conservation of resources, freedom from child
                  labour, secularism, global peace and multi-culturalism. Go
                  green by carrying cloth bags. Restrict the use of plastics.
                  Begin a signature campaign to bring about social harmony.{" "}
                </li>
              </ul>
              <h6>
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/child-abuse.pdf"
                  target="_blank"
                >
                  <b>
                    <u>CHILD ABUSE MANAGEMENT COMMITTEE</u>
                  </b>
                </Link>
              </h6>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CodeConduct;
